/**
 * Media query breakpoints - Mobile-first responsive design
 * Small Phones: < 480px (base styles)
 * Phones: 481px – 767px
 * Tablets: 768px – 1023px
 * Small Laptops: 1024px – 1279px
 * Desktops: 1280px – 1439px
 * Large Screens: 1440px+
 */
export const media = {
  mobileS: 480,
  mobile: 767,
  tablet: 1023,
  laptop: 1279,
  desktop: 1439,
  large: 1440,
};

/**
 * Convert a px string to a number
 */
export const pxToNum = px => Number(px.replace('px', ''));

/**
 * Convert a number to a px string
 */
export const numToPx = num => `${num}px`;

/**
 * Convert pixel values to rem for a11y
 */
export const pxToRem = px => `${px / 16}rem`;

/**
 * Convert ms token values to a raw numbers for ReactTransitionGroup
 * Transition delay props
 */
export const msToNum = msString => Number(msString.replace('ms', ''));

/**
 * Convert a number to an ms string
 */
export const numToMs = num => `${num}ms`;

/**
 * Convert an rgb theme property (e.g. rgbBlack: '0 0 0')
 * to values that can be spread into a ThreeJS Color class
 */
export const rgbToThreeColor = rgb => rgb.split(' ').map(value => Number(value) / 255);
